// extracted by mini-css-extract-plugin
module.exports = {"searchWrapper":"Search_searchWrapper__38ZJs","icon":"Search_icon__151oZ","search":"Search_search__1dh6h"};